import React, { useState, useEffect } from 'react'
import { Box, Flex, Select, Group, Button } from '@mantine/core'

const defaultParams = {
  'page[num]': 1,
  'page[limit]': 10,
  sort: '-id',
  include: 'categories,creator,updater',
  'fields[user]' : 'name',
  'filter[menu_type][is]': null
}

const defaultMenuType = [
  {
    label: 'Article',
    value: 'article'
  },
  {
    label: 'Video',
    value: 'video'
  },
  {
    label: 'Event',
    value: 'event'
  },
  {
    label: 'Tutorial',
    value: 'tutorial'
  },
]

const FormFilterMenu = ({ paramsCustomMenu, applyFilter, onClose }) => {
  const [parameter, setParameter] = useState(defaultParams)

  useEffect(() => {
    if (paramsCustomMenu !== null) {
      handleSetParams(paramsCustomMenu)
    }
    // eslint-disable-next-line
  }, [paramsCustomMenu])

   const handleSetParams = (val) => {
    const prevParams = {
      'filter[menu_type][is]': val['filter[menu_type][is]']
    }
    setParameter(prevParams)
  }

  const handleChangeFilter = (name, val) => {
    setParameter((oldVal) => ({ ...oldVal, [name]: val}))
  }

  const handleApplyFilter = (params) => {
    const valueParams = {
      ...params,
      'page[num]': 1,
      'page[limit]': 10,
    }
    applyFilter(valueParams)
    onClose()
  }

  return (
    <Box>
      <Box mb='md'>
        <Select
          name='filter[menu_type][is]'
          value={parameter['filter[menu_type][is]']}
          label='Featured'
          data={defaultMenuType}
          onChange={(val) => handleChangeFilter('filter[menu_type][is]', val)}
          size='xs'
          clearable
        />
      </Box>
      <Box mt={20}>
        <Flex justify='flex-end'>
          <Group>
            <Button size='xs' variant="outline" onClick={onClose}>Close</Button>
            <Button size='xs' variant="filled" onClick={() => handleApplyFilter(parameter)}>Apply Filter</Button>
          </Group>
        </Flex>
      </Box>
    </Box>
  )
}

export default FormFilterMenu